import React from 'react';
import PropTypes from 'prop-types';
import RulesGrid from 'shared/components/rulesGrid/RulesGrid';
import { pageBackgroundGray } from 'theme/mainColors';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';

class RulesOperations extends React.PureComponent {
  state = {
    perPage: 10,
    page: 0
  };

  componentWillMount() {
    this.props.rulesActions.fetchRules(0, 10);
  }

  handlePageChange = (page, perPage) => {
    this.props.rulesActions.fetchRules(page, perPage);
    this.setState({ perPage, page });
  };

  handleDeleteRule = ruleId => {
    const { page, perPage } = this.state;
    this.props.rulesActions.deleteRule(ruleId, page, perPage);
  };

  handleEditRule = ruleId => this.props.rulesActions.fetchRule(ruleId);

  render() {
    const { rules, totalEntries, fetchingRules } = this.props;
    return (
      <div className="rules-operations__main-container">
        <RulesGrid
          rulesListGridData={ rules }
          showPagination={ true }
          onPageChange={ this.handlePageChange }
          totalItems={ totalEntries }
          fetchingRules={ fetchingRules }
          backgroundColor={ pageBackgroundGray }
          showMoreActionsIcon={ true }
          onDeleteRule={ this.handleDeleteRule }
          onEditRule={ this.handleEditRule }
        />
      </div>
    );
  }
}

RulesOperations.propTypes = {
  rules: PropTypes.arrayOf(RULE_PROP_TYPE),
  totalEntries: PropTypes.number.isRequired,
  fetchingRules: PropTypes.bool.isRequired,
  rulesActions: PropTypes.shape({
    fetchRules: PropTypes.func,
    deleteRule: PropTypes.func,
    fetchRule: PropTypes.func
  }).isRequired
};

export default RulesOperations;



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/rulesOperations/RulesOperations.js